import React from 'react'

const CustomHr = () => {
    return (
        <>
            <hr className='custom-hr' />
        </>
    )
}

export default CustomHr
